// extracted by mini-css-extract-plugin
export default {"x":"PtqKvJ2eElKoNhfsH89g","close":"A7Db8Ye3urKctmsc_Mhs"};